module.exports = __webpack_public_path__ + "static/media/marek-contact.41570053.png";